/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ListingOneAlgorithmSimulation } from '../models/ListingOneAlgorithmSimulation';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class ListingOneAlgorithmSimulationService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Retrieves a ListingOneAlgorithmSimulation resource.
     * Retrieves a ListingOneAlgorithmSimulation resource.
     * @param accommodationId
     * @param listingType
     * @param listingId
     * @param reviewsVolume
     * @param accommodationMultiplier
     * @param reservationType
     * @param roomFit
     * @param activeReservation
     * @param provision
     * @param conversion
     * @param availabilityMultiplier
     * @param aovSegmentation
     * @param constListingMultiplier
     * @returns ListingOneAlgorithmSimulation ListingOneAlgorithmSimulation resource
     * @throws ApiError
     */
    public apiAccommodationslistingoneAlgorithmsimulationotaGet(
        accommodationId?: string,
        listingType?: string,
        listingId?: string,
        reviewsVolume?: number,
        accommodationMultiplier?: number,
        reservationType?: number,
        roomFit?: number,
        activeReservation?: number,
        provision?: number,
        conversion?: number,
        availabilityMultiplier?: number,
        aovSegmentation?: number,
        constListingMultiplier?: number,
    ): CancelablePromise<ListingOneAlgorithmSimulation> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/accommodations/listing/one-algorithm/simulation/ota',
            query: {
                accommodationId: accommodationId,
                listingType: listingType,
                listingId: listingId,
                reviewsVolume: reviewsVolume,
                accommodationMultiplier: accommodationMultiplier,
                reservationType: reservationType,
                roomFit: roomFit,
                activeReservation: activeReservation,
                provision: provision,
                conversion: conversion,
                availabilityMultiplier: availabilityMultiplier,
                aovSegmentation: aovSegmentation,
                constListingMultiplier: constListingMultiplier,
            },
            errors: {
                400: `Bad request`,
                403: `Forbidden`,
                404: `Not found`,
                500: `Internal server error`,
            },
        });
    }
}
